module.exports = __webpack_public_path__ + "static/media/SPIRITSWAP-FTM-TAROT.681a202c.png";